import React from 'react';
import { Select } from '@chakra-ui/react';
import { CALL_TIMEZONE_OPTIONS } from '../utils/callTimezone';

export default function CallTimezoneSelect({ value, onChange, lang = 'en' }) {
  return (
    <Select
      aria-label={lang === 'zh' ? '时间显示时区' : 'Time zone for call times'}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      maxW="240px"
      size="sm"
    >
      {CALL_TIMEZONE_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>{lang === 'zh' ? option.zh : option.en}</option>
      ))}
    </Select>
  );
}
